var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-container',{attrs:{"fluid":_vm.isRealXl}},[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"cols":"12","md":"9"}},[_c('contact-list')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }